import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class AssessmentDetailService {
  private baseUrl = "/api/v1/assessment-details"; // Replace with your Laravel API URL

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  getAllAssessmentDetails(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrl}`, { headers });
  }

  getAssessmentDetailById(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrl}/${id}`, { headers });
  }

  createAssessmentDetail(data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(`${this.baseUrl}`, data, { headers });
  }

  updateAssessmentDetail(id: number, data: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(`${this.baseUrl}/${id}`, data, { headers });
  }

  deleteAssessmentDetail(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(`${this.baseUrl}/${id}`, { headers });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/assessment-detail.service.ts